// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1494":"04ae4864","2803":"cffbe535","6530":"04ae4864","7121":"04ae4864"}[chunkId] + ".chunk.css";
};